// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "c260b8a79309";
export const BUILD_VERSION_NUMBER = 18;
